import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, finalize, Observable, take } from 'rxjs';
import { BANNER_TYPE } from 'src/app/components/banner/banner.constants';
import { CommonUtils } from 'src/app/core/utils/common/common.utils';
import { environment } from 'src/app/environments/environment';
import {
  ArriveDepartUldTypeResponse,
  ArriveLoad,
  ArriveLoadResponse,
  ArriveManualLoadResponse,
  ArriveResponse,
  CreateArriveLoadRequest,
} from '../../../models/arrive-depart/arrive.model';
import { ErrorhandleService } from '../../error-handling/error-handle/errorhandle.service';

@Injectable({
  providedIn: 'root',
})
export class ArriveService {
  readonly baseUrl = environment.apiUrl.concat('/arrive-depart/');
  constructor(
    private http: HttpClient,
    private commonUtils: CommonUtils,
    private errorHandler: ErrorhandleService,
  ) {}

  /**
   *arrive manual loads
   * @return {*}  {Observable<ArriveManualLoadResponse>}
   * @memberof ArriveService
   */
  arriveManualLoads(
    createArriveLoadRequest: CreateArriveLoadRequest,
  ): Observable<ArriveManualLoadResponse> {
    this.commonUtils.updateLoadingModal(true);
    return this.http
      .post<ArriveManualLoadResponse>(
        this.baseUrl.concat('manual-arrive-loads'),
        createArriveLoadRequest,
      )
      .pipe(
        take(1),
        catchError((error) =>
          this.errorHandler.handleError<ArriveManualLoadResponse>(
            error,
            error.error.code,
            'Arrive Service: post arrive manual loads',
            BANNER_TYPE.API_400_ERROR,
          ),
        ),
        finalize(() => {
          this.commonUtils.updateLoadingModal(false);
        }),
      );
  }

  /**
   *Get arrive loads
   * @return {*}  {Observable<ArriveResponse>}
   * @memberof ArriveService
   */
  getArriveLoads(): Observable<ArriveResponse> {
    this.commonUtils.updateLoadingModal(true);
    return this.http
      .get<ArriveResponse>(this.baseUrl.concat('get-arrive-loads'))
      .pipe(
        take(1),
        catchError((error) =>
          this.errorHandler.handleError<ArriveResponse>(
            error,
            error.error.code,
            'Arrive Service: get arriveable loads',
            BANNER_TYPE.TABLE_DATA_ERROR,
          ),
        ),
        finalize(() => {
          this.commonUtils.updateLoadingModal(false);
        }),
      );
  }

  /**
   *arrive loads
   * @return {*}  {Observable<ArriveLoadResponse>}
   * @memberof ArriveService
   */
  arriveLoads(arriveLoadRequest: ArriveLoad): Observable<ArriveLoadResponse> {
    this.commonUtils.updateLoadingModal(true);
    return this.http
      .post<ArriveLoadResponse>(
        this.baseUrl.concat('arrive'),
        arriveLoadRequest,
      )
      .pipe(
        take(1),
        catchError((error) =>
          this.errorHandler.handleError<ArriveLoadResponse>(
            error,
            error.error.code,
            'Arrive Service: arrive loads',
            BANNER_TYPE.API_400_ERROR,
          ),
        ),
        finalize(() => {
          this.commonUtils.updateLoadingModal(false);
        }),
      );
  }
  /**
   *Get arrive depart uld type
   * @return {*}  {Observable<ArriveResponse>}
   * @memberof ArriveService
   */
  getArriveDepartUldType(): Observable<ArriveDepartUldTypeResponse> {
    this.commonUtils.updateLoadingModal(true);
    return this.http
      .get<ArriveDepartUldTypeResponse>(
        this.baseUrl.concat('arrive-depart-uldTypes'),
      )
      .pipe(
        take(1),
        catchError((error) =>
          this.errorHandler.handleError<ArriveDepartUldTypeResponse>(
            error,
            error.error.code,
            'Arrive Service: arrive depart uldTypes',
            BANNER_TYPE.API_400_ERROR,
          ),
        ),
        finalize(() => {
          this.commonUtils.updateLoadingModal(false);
        }),
      );
  }
}
